module.exports = __webpack_public_path__ + "img/instructions.aa05514f.svg";